export function blockScrollMobile() {
  document.body.style.overflow = 'hidden';
}

export function restoreScrollMobile() {
  document.body.style.overflow = '';
}

export function blockScrollDesktop() {
  document.body.style.height = '100vh';
  document.body.style.paddingRight =
    window.innerWidth - document.documentElement.clientWidth + 'px';
  document.body.style.overflowY = 'hidden';
}

export function restoreScrollDesktop() {
  document.body.style.paddingRight = '';
  document.body.style.overflowY = '';
  document.body.style.height = '';
}
